// extracted by mini-css-extract-plugin
module.exports = {"slideContent":"Slides_slideContent__bQbo2","slide__button":"Slides_slide__button__3xjW9","verticalCenter":"Slides_verticalCenter__2zSlq"};